export const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  lbl: {
    display: "block",
    fontWeight: "bold",
  },
});
